module.exports = __webpack_public_path__ + "media/application/images/external-services/shopify-logo-020072b58bbdc291aa7f6ae089c9cf68.svg";